import { useFormik } from 'formik';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import BaseURL from '../Utilities/BaseUrl';
import axios from 'axios';
import { Validate } from '../Utilities/Passwordvalidation';
import * as Yub from 'yup';
import {cartContext}from'../Contexts/CartContext';
import { Helmet } from 'react-helmet';
export default function Resetpassword() {
  let {setcheck}=useContext(cartContext);
    const [errormesg, seterrormesg] = useState("");
    const [sucessmesg, setsucessmesg] = useState("");
    const [loading, setloading] = useState(true);
    const [disab, setdisab] = useState(true);
    let navigate = useNavigate();
   let validationschema=Yub.object({
     
    email:Yub.string().required('Your Email is required ').matches(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,'Your Email not Valid')

   })
    function tranferPass() {
      let ey1 = document.querySelector(".eye1");
      let inp1 = document.querySelector("#newPassword");
      ey1.innerHTML = `<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`;
      inp1.setAttribute("type", Text);
    }
    let Formik = useFormik({
      initialValues: {
        email: "",
        newPassword: "",
      },

   validate:Validate,
 validationSchema:validationschema,

      onSubmit: (values) => {
        setloading(false);
        setdisab(false);
        axios.put(`${BaseURL}auth/resetPassword`, values
          
          )
          .then((data) => {
            if (data.status == 200) {
              
              setsucessmesg(data.data.message);
              setTimeout(() => {
                navigate("/login");
              }, 1000);
            }
          })
          .catch((error) => {
            if (error.response.status == 400)
            {
               seterrormesg(error.response.data.message);
             
               setloading(true)
               setdisab(true)
            }
              
          });
        }
      
      })
      useEffect(() => {
        setcheck(true);
      
        
      }, [])

  return<>
  <Helmet>
        <title>Resetpassword</title>
        
    </Helmet>
  <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
      <div className="loginForm">

      {errormesg !=''? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 ">
              <div
                id="liveToast"
                className="toast  show  "
                role="alert"
                aria-live="assertive"
                aria-atomic="true"
              >
                <div className="toast-header position-relative  border-0 bg-danger ">
                  <button
                    type="button"
                    className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                    data-bs-dismiss="toast"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="toast-body text-center bg-danger pb-3 fw-bold text-white">
                 Error !..  { errormesg}
                </div>
              </div>
            </div>
             : 
              ""
            }

{sucessmesg ? 
              <div className="position-fixed top-10 end-80 p-3 mt-5 bg-sucess">
                <div
                  id="liveToast"
                  className="toast  show  "
                  role="alert"
                  aria-live="assertive"
                  aria-atomic="true"
                >
                  <div className="toast-header position-relative  border-0 bg-success">
                    <button
                      type="button"
                      className="btn-close position-absolute end-0 me-2 mt-2 shadow-none"
                      data-bs-dismiss="toast"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div className="toast-body text-center bg-success pb-3 fw-bold text-white">
                    {sucessmesg } 
                  </div>
                </div>
              </div>
             : 
              ""
            }
        <h2 className="mb-5">Reset Password Now .....</h2>

        <form onSubmit={Formik.handleSubmit}>
          <label htmlFor="email">Email :</label>
          <input
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            type="email"
            name="email"
            id="email"
            placeholder="Enter Your Email"
            className="form-control mt-2 w-75 mb-4 shadow-none"
            value={Formik.values.email}
          />
          {Formik.errors.email && Formik.touched.email ? (
            <div className="alert alert-danger w-75">{Formik.errors.email}</div>
          ) : (
            ""
          )}

          <label htmlFor="newPassword">newPassword :</label>
          <div className="passwordField">
            <input
              onChange={Formik.handleChange}
              onBlur={Formik.handleBlur}
              type="password"
              name="newPassword"
              id="newPassword"
              placeholder="Enter Your password"
              className="form-control mt-2 w-75 mb-4 shadow-none"
              value={Formik.values.newPassword}
            />{" "}
            <span className="eye1">
              <i
                className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer"
                onClick={tranferPass}
              ></i>
            </span>
          </div>
          {Formik.errors.newPassword && Formik.touched.newPassword ? (
            <div className="alert alert-danger w-75">
              {Formik.errors.newPassword}
            </div>
          ) : (
            ""
          )}
          <button
            type="submit"
            className="btn bg-main px-5 py-2 mt-5 text-white"
            disabled={!(Formik.isValid && Formik.dirty && disab)}
          >
            {loading ? (
              <span>Continue</span>
            ) : (
              <span
                className="spinner-border text-white "
                role="status"
                width={10}
              ></span>
            )}
          </button>
        </form>
      </div></div></div></div>
  
  
  </>


}
